<template>
    <div v-if="!loadingPage">
        <h3 class="text-primary mb-2 mt-50">تنظیمات تصاویر درباره ما</h3>
        <b-card v-if="isAdminIdentityVerified">
            <b-card-body>
                <div class="row">
                    <b-form-group label="تصویر" class="col-12 col-md-3">
                        <div class="d-flex align-items-center position-relative">
                            <b-form-file ref="imageFile" browse-text="بارگذاری" v-model="imageFile" @change="addImage"
                                :disabled="loading" placeholder="" />
                            <div class="position-absolute d-flex align-items-center" style="z-index: 1;left: 85px;">
                                <b-spinner v-if="loading" variant="primary" small></b-spinner>
                            </div>

                        </div>
                    </b-form-group>
                </div>

                <div v-if="images.length" class="row mt-2 mt-md-3">
                    <div v-for="(item, index) in images" :key="index" class="col-12 col-md-4 mb-2">
                        <div style="height: 250px;border: 3px solid #7267f0ce;border-radius: 15px;"
                            class="position-relative">
                            <div @click="removeImage(item.path)"
                                class="position-absolute pointer bg-primary rounded-circle p-25"
                                style="left: 4px;top: 4px;z-index: 1;">
                                <feather-icon size="22" icon="XIcon" class="text-white" />
                            </div>
                            <div class="w-100 h-100">
                                <img :src="BASE_URL_File + item.path" class="w-100 h-100 image-about-us">
                            </div>
                            <div v-if="!item.isAcepted"
                                class="position-absolute d-flex justify-content-center align-items-center w-100 h-100"
                                style="top: 0;background-color: rgba(0, 0, 0, 0.6);border-radius: 12px;">
                                <div class="text-warning font-weight-bolder h4 mb-0">
                                    در حال بررسی
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </b-card-body>
        </b-card>
        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>

<script>
import Compressor from 'compressorjs';
import { BButton, BCard, BCardText, BAvatar, BSpinner, BCardBody, BFormFile, BFormGroup } from 'bootstrap-vue';
import { storeService } from '@core/services';


export default {
    components: {
        BFormFile,
        BCard,
        BCardText,
        BCardBody,
        BAvatar,
        BButton,
        BSpinner,
        BFormGroup
    },
    data() {
        return {
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            loading: false,
            loadingPage: true,
            isAdminIdentityVerified: false,
            imageFile: null,
            storeId: null,
            images: [],
        };
    },
    methods: {
        addImage(event) {
            this.loading = true;
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            let formData = new FormData();
                            formData.append("imageFile", result, result.name)
                            storeService.addImage(this.storeId, formData).then(({ data }) => {
                                this.getInfo();
                                this.$notif({ type: 'success', title: 'بارگذاری تصویر با موفقیت انجام شد' });
                            })
                                .finally(() => {
                                    this.imageFile = null
                                    this.loading = false;
                                });
                        },
                    });

                }
                else {
                    this.$refs.imageFile.reset();
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                    this.imageFile = null
                    this.loading = false;
                }
            }
            else {
                this.$refs.imageFile.reset();
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
                this.imageFile = null
                this.loading = false;
            }
        },
        removeImage(item) {
            storeService.removeImage(this.storeId, { image: item }).then(({ data }) => {
                this.images = this.images.filter(value => value.path !== item);
                this.$notif({ type: 'success', title: 'تصویر با موفقیت حذف شد' });
            })
        },
        getInfo() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                this.images = data.images
            })
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                this.loadingPage = false;
                if (this.isAdminIdentityVerified) {
                    this.getInfo();
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId");
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
.custom-file-label {
    padding-top: 9px;

    &::after {
        padding-top: 8px;
    }
}

.image-about-us {
    border-radius: 12px;
    object-fit: cover;
}
</style>